import combineReducers from 'react-combine-reducers';
import modalReducer from './reducers/modal.reducer';

const reducers = combineReducers({
  modalCtx: modalReducer,
});

export default reducers;